export default __webpack_public_path__ + "static/media/loader-row.6d022ff8.svg";